import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {
    Autocomplete,
    IconButton,
    Stack,
    TextField,
} from "@mui/material";
import { Form, Formik, getIn } from "formik";
import * as Yup from "yup";
import { Close } from "@mui/icons-material";
import { useUpdateStylesMutation } from "../../Slices/roomNateApis";
import { ErrorAlert, SuccessAlert } from "../../utils/Alerts";
import { LoadingButton } from "@mui/lab";
import {
    Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    height: "90%",
    overflowY: "auto",
    width: { xs: "90%", md: "650px" },
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

export default function BasicModal({ item, FetchStyles }) {

    const formRef = React.useRef();
    const [updateStyles, resultStats] = useUpdateStylesMutation();

    const [open, setOpen] = React.useState(false);
    const [load, setLoad] = React.useState(false);
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("name is required"),
        description: Yup.string().required("description is required"),
        parentStyle: Yup.mixed().notRequired("parentStyle is not required")
    });

    React.useEffect(() => {
        if (resultStats?.isLoading) {
            setLoad(true);
        }

        if (!resultStats?.isLoading) {
            setLoad(false);
        }

        if (resultStats?.isSuccess) {
            setSuccessAlert(true);
            setTimeout(() => {
                setSuccessAlert(false);
            }, 2000);
            handleClose();
        }

        if (resultStats?.isError) {
            setErrorAlert(true);
            setTimeout(() => {
                setErrorAlert(false);
            }, 2000);
        }
    }, [resultStats]);

    const styles = [...FetchStyles]
    const filteredArray = styles.filter((element) => element._id !== item._id);

    return (
        <>
            {successAlert && (
                <SuccessAlert title="Style has been updated successfully!" />
            )}

            {errorAlert && <ErrorAlert title="Something Went Wrong!" />}

            <Tooltip title="Edit">
                <IconButton color="primary" onClick={handleOpen}>
                    <EditIcon />
                </IconButton>
            </Tooltip>

            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box position="fixed" top={10} right={0}>
                        <IconButton onClick={handleClose}>
                            <Close />
                        </IconButton>
                    </Box>
                    <Formik
                        innerRef={formRef}
                        enableReinitialize={true}
                        initialValues={{
                            name: item?.name,
                            description: item?.description,
                            parentStyle: FetchStyles?.find((item1) => item1._id === item?.parentStyle)?._id
                        }}
                        validationSchema={validationSchema}
                        onSubmit={(values, { setSubmitting }) => {
                            setSubmitting(false);
                            const {
                                name, description, parentStyle,
                            } = values;

                            updateStyles({ id: item._id, data: { name, description, parentStyle: parentStyle || null } });
                        }}
                    >
                        {({
                            values,
                            touched,
                            errors,
                            handleChange,
                            handleBlur,
                            setValues,
                        }) => (
                            <Form noValidate autoComplete="off">
                                <Typography
                                    id="modal-modal-title"
                                    fontWeight={"bold"}
                                    fontSize={"20px"}
                                    npmsvariants="h6"
                                    mb={2}
                                >
                                    Update a Style
                                </Typography>

                                <Stack my={2}>
                                    <TextField
                                        id="outlined-basic"
                                        label="Name"
                                        variants="outlined"
                                        name="name"
                                        fullWidth
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.name}
                                        required
                                        helperText={
                                            getIn(touched, "name") && getIn(errors, "name")
                                                ? getIn(errors, "name")
                                                : ""
                                        }
                                        error={Boolean(
                                            getIn(touched, "name") && getIn(errors, "name")
                                        )}
                                    />
                                </Stack>

                                <Stack my={2}>
                                    <TextField
                                        id="outlined-basic"
                                        label="Desciption"
                                        variants="outlined"
                                        name="description"
                                        fullWidth
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.description}
                                        required
                                        helperText={
                                            getIn(touched, "description") && getIn(errors, "description")
                                                ? getIn(errors, "description")
                                                : ""
                                        }
                                        error={Boolean(
                                            getIn(touched, "description") && getIn(errors, "description")
                                        )}
                                    />
                                </Stack>

                                {FetchStyles?.length >= 2 &&
                                    < Autocomplete
                                        fullWidth
                                        disablePortal
                                        onChange={(_, value) =>
                                            setValues({
                                                ...values,
                                                parentStyle: value?._id
                                            })
                                        }
                                        value={FetchStyles?.find(
                                            (item) =>
                                                item._id ===
                                                values?.parentStyle
                                        )}
                                        name={`parentStyle`}
                                        id="combo-box-demo"
                                        options={filteredArray}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => (
                                            <TextField
                                                placeholder={
                                                    "Select ParentStyle"}
                                                name={`parentStyle`}
                                                {...params}
                                                onBlur={handleBlur}
                                                helperText={
                                                    getIn(touched, "parentStyle") &&
                                                        getIn(errors, "parentStyle")
                                                        ? getIn(errors, "parentStyle")
                                                        : ""
                                                }
                                                error={Boolean(
                                                    getIn(touched, "parentStyle") &&
                                                    getIn(errors, "parentStyle")
                                                )}
                                            />
                                        )}
                                    />
                                }

                                <Stack mt={2}>
                                    <LoadingButton
                                        loading={load}
                                        variant="contained"
                                        fullWidth
                                        type="submit"
                                    >
                                        Save
                                    </LoadingButton>
                                </Stack>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Modal>
        </>
    );
} 
